module.exports = __webpack_public_path__ + "3b879ba55918035c448cff1ab8eef5aa.MP3";